import moment from 'moment';

import { fromAnyDateToIso, fromAnyDateToTimestamp, fromAnyDateToZulu } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';

const L = logger('repairDstTransition'); // eslint-disable-line no-unused-vars

const repairDstTransition = (options) => {
  const { isDstOld, isDstNew, date: dateFromOptions, returnType } = options ?? {};

  // if you give moment() undefined, it will take the current date/time, we don't want that
  const parsed = moment(dateFromOptions ?? null);
  L.debug('()', 'parsed:', fromAnyDateToIso(parsed), '<-', parsed, '|', options);

  let date;
  if (isDstOld && !isDstNew) {
    date = parsed.add(1, 'hour');
  } else if (!isDstOld && isDstNew) {
    date = parsed.add(-1, 'hour');
  } else {
    date = parsed;
  }

  if ('moment' === returnType) return date;
  if ('zulu' === returnType) return fromAnyDateToZulu(date);
  if ('timestamp' === returnType) return fromAnyDateToTimestamp(date);

  return fromAnyDateToIso(date);
};

export default repairDstTransition;
